import {TimeSlotItem} from './TimeSlotList';

export const countDiscountedTimeslots = (
  timeslots: TimeSlotItem[] | undefined,
) => {
  if (!timeslots) return 0;
  return timeslots.filter((slot) => {
    return (slot.discountPercentage ?? 0) > 0;
  }).length;
};
